import { render, staticRenderFns } from "./LotCard.vue?vue&type=template&id=4a178969&scoped=true&"
import script from "./LotCard.vue?vue&type=script&lang=js&"
export * from "./LotCard.vue?vue&type=script&lang=js&"
import style0 from "./LotCard.vue?vue&type=style&index=0&id=4a178969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a178969",
  null
  
)

export default component.exports